/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Interview_Practice_Char_CountInputs */

const en_interview_practice_char_count = /** @type {(inputs: Interview_Practice_Char_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} characters`)
};

const de_interview_practice_char_count = /** @type {(inputs: Interview_Practice_Char_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Zeichen`)
};

const fr_interview_practice_char_count = /** @type {(inputs: Interview_Practice_Char_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} caractères`)
};

const es_interview_practice_char_count = /** @type {(inputs: Interview_Practice_Char_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} caracteres`)
};

const it_interview_practice_char_count = /** @type {(inputs: Interview_Practice_Char_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} caratteri`)
};

const nl_interview_practice_char_count = /** @type {(inputs: Interview_Practice_Char_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} tekens`)
};

const pl_interview_practice_char_count = /** @type {(inputs: Interview_Practice_Char_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} znaków`)
};

const fi_interview_practice_char_count = /** @type {(inputs: Interview_Practice_Char_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} merkkiä`)
};

const da_interview_practice_char_count = /** @type {(inputs: Interview_Practice_Char_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} tegn`)
};

const sv_interview_practice_char_count = /** @type {(inputs: Interview_Practice_Char_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} tecken`)
};

/**
* | output |
* | --- |
* | "{count} characters" |
*
* @param {Interview_Practice_Char_CountInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_practice_char_count = /** @type {((inputs: Interview_Practice_Char_CountInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Practice_Char_CountInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_practice_char_count(inputs)
	if (locale === "fr") return fr_interview_practice_char_count(inputs)
	if (locale === "es") return es_interview_practice_char_count(inputs)
	if (locale === "it") return it_interview_practice_char_count(inputs)
	if (locale === "nl") return nl_interview_practice_char_count(inputs)
	if (locale === "pl") return pl_interview_practice_char_count(inputs)
	if (locale === "fi") return fi_interview_practice_char_count(inputs)
	if (locale === "da") return da_interview_practice_char_count(inputs)
	if (locale === "sv") return sv_interview_practice_char_count(inputs)
	return en_interview_practice_char_count(inputs)
});